import React from 'react'
import { Card, Row } from 'antd'
import { EmptyHeaderHero, Header, Footer } from './components'

const NotFound = () => {
  return (
    <div className="not-found-container">
      <Header />
      <EmptyHeaderHero title="Sorry." />
      <div className="not-found-screen">
        <Row>
          <Card className="not-found-card">
            <p>The page or address you are looking for could not be found.</p>
          </Card>
        </Row>
      </div>
      <Footer />
    </div>
  )
}

NotFound.propTypes = {}

export default NotFound
